module.exports = {
  invoice_drawCollectInvoice: 'ออกใบแจ้งหนี้/รับใบแจ้งหนี้',
  invoice_queryInvoice: 'ค้นหาใบแจ้งหนี้',
  invoice_invoiceCategory: 'ประเภทใบแจ้งหนี้',
  invoice_invoiceDownloadLabel: 'ดาวน์โหลด',
  invoice_electronicInvoiceDownload: 'ดาวน์โหลดใบแจ้งหนี้อิเล็กทรอนิกส์',
  invoice_sendEmail: 'ส่ง',
  invoice_mailSend: 'ส่งอีเมล',
  invoice_sendEmailLog: 'บันทึก',
  invoice_downloadTimes: 'จำนวนครั้งที่ลูกค้าดาวน์โหลด',
  invoice_electronicInvoiceSendStatus: 'สถานะการส่งใบแจ้งหนี้อิเล็กทรอนิกส์',
  invoice_download: 'ดาวน์โหลด',
  invoice_salesDepartment: 'แผนกขาย',
  invoice_opDepartment: 'แผนกปฏิบัติการ',
  invoice_chineseDescriptionOfGoods: 'ชื่อสินค้า (จีน)',
  invoice_englishDescriptionOfGoods: 'ชื่อสินค้า (อังกฤษ)',
  billingJob_taxRate: 'อัตราภาษี',
  invoice_hedging: 'การหักกลบลบหนี้',
  invoice_selectTheHedging: 'กรุณาค้นหาและเลือกรายการที่จะหักกลบลบหนี้',
  invoice_return: 'กลับ',
  invoice_query: 'ค้นหา',
  invoice_invoicing: 'ออกใบแจ้งหนี้',
  invoice_collectInvoice: 'รับใบแจ้งหนี้',
  billingJob_billDate: 'วันที่บิล',
  invoice_confirm: 'ยืนยัน',
  invoice_hedgingInvoice: 'ออกใบแจ้งหนี้หักกลบลบหนี้',
  invoice_hedgingCollectingInvoice: 'รับใบแจ้งหนี้หักกลบลบหนี้',
  invoice_cancelBillConfirmation: 'ยกเลิกการยืนยันบิล',
  invoice_revenueAndExpenditureMethod: 'วิธีการรับ/จ่าย:',
  invoice_all: 'ทั้งหมด',
  invoice_convert: 'แปลงเป็น',
  invoice_convert_after_tax: 'แปลงเป็นราคาไม่รวมภาษี',
  invoice_receivables: 'ต้องรับ',
  invoice_payables: 'ต้องจ่าย',
  invoice_feeType: 'ประเภทค่าใช้จ่าย:',
  invoice_domestic: 'ในประเทศ',
  invoice_international: 'ต่างประเทศ',
  invoice_charges: 'ค่าใช้จ่าย',
  invoice_business: 'ธุรกิจ',
  invoice_bill: 'บิล',
  invoice_accountStatement: 'ใบเปรียบเทียบบิล',
  invoice_defaultInformation: 'ออกใบแจ้งหนี้ตามข้อมูลเริ่มต้น',
  invoice_customer: 'ลูกค้า',
  invoice_businessNumber: 'เลขที่ธุรกิจ',
  invoice_consignationCompany: 'หน่วยมอบหมาย',
  invoice_settlementCompany: 'หน่วยชำระเงิน',
  invoice_mblNo: 'เลขที่เอกสารหลัก',
  invoice_vessel: 'ชื่อเรือ',
  invoice_voyage: 'เที่ยวบิน/เที่ยวเรือ',
  invoice_billNo: 'เลขที่บิล',
  invoice_accountStatementNo: 'เลขที่ใบเปรียบเทียบบิล',
  invoice_paymentApplicationNo: 'เลขที่คำขอชำระเงิน',
  invoice_itemNo: 'เลขที่โครงการ',
  invoice_bookingNo: 'เลขที่การจองพื้นที่',
  invoice_businessType: 'ประเภทธุรกิจ',
  invoice_solicitationType: 'ประเภทการรับสินค้า',
  invoice_amountRange: 'ช่วงจำนวนเงิน',
  invoice_chargeItem: 'ชื่อค่าใช้จ่าย',
  invoice_customerTypeId: 'ประเภทลูกค้า',
  invoice_businessDate: 'วันที่ทำธุรกรรม',
  invoice_receivablesInvoicingDate: 'วันที่ออกใบแจ้งหนี้',
  invoice_currency: 'สกุลเงิน',
  invoice_operation: 'การดำเนินการ',
  invoice_sales: 'ฝ่ายขาย',
  invoice_cargoSalesId: 'พนักงานขายรับสินค้า',
  invoice_advanceMoneyForAnotherOrNot: 'มีการจ่ายแทนหรือไม่',
  invoice_adjustedOrNot: 'มีการปรับหรือไม่',
  invoice_wroteOffOrNot: 'มีการตัดจ่ายหรือไม่',
  invoice_generatedBillsOrNot: 'มีการสร้างบิลหรือไม่',
  invoice_invoicedOrNot: 'มีการออกใบแจ้งหนี้หรือไม่',
  invoice_appliedForPaymentOrNot: 'มีการขอชำระเงินหรือไม่',
  invoice_receivablesInvoicingStatus: 'สถานะใบแจ้งหนี้',
  invoice_payablesInvoicingStatus: 'สถานะใบแจ้งหนี้ที่ต้องจ่าย',
  invoice_department: 'แผนก',
  invoice_customerLevel: 'ระดับลูกค้า',
  invoice_settlementMethod: 'วิธีการชำระเงิน',
  invoice_contactPerson: 'ผู้ติดต่อ',
  invoice_businessReferenceNumber: 'เลขที่อ้างอิงธุรกรรม',
  invoice_invoiceHeader: 'ชื่อในใบแจ้งหนี้',
  invoice_inputBy: 'ผู้สร้างใบแจ้งหนี้',
  invoice_dateCreated: 'เวลาที่สร้างใบแจ้งหนี้',
  invoice_accrued: 'มีการบันทึกแล้ว',
  invoice_invoicingMethod: 'วิธีการออกใบแจ้งหนี้',
  invoice_businessStatus: 'สถานะธุรกรรม',
  invoice_feeStatus: 'สถานะค่าใช้จ่าย',
  invoice_confirmStatus: 'สถานะการยืนยัน',
  invoice_vesselAndVoyage: 'ชื่อเรือและเที่ยวบิน',
  invoice_portOfLoading: 'ท่าเรือต้นทาง',
  invoice_portOfDestination: 'ท่าเรือปลายทาง',
  invoice_financialDate: 'วันที่ทางการเงิน',
  invoice_domesticOrInternational: 'ในประเทศ/ต่างประเทศ',
  invoice_paymentType: 'ประเภทการชำระเงิน',
  invoice_quantity: 'จำนวน',
  invoice_taxIncludedPrice: 'ราคารวมภาษี',
  invoice_taxExcludedPrice: 'ราคาไม่รวมภาษี',
  invoice_taxAmount: 'จำนวนภาษี',
  invoice_theAmountOfWriteOffs: 'จำนวนเงินที่ตัดจ่าย',
  invoice_amountNotWrittenOff: 'จำนวนเงินที่ยังไม่ตัดจ่าย',
  invoice_chargesRemarks: 'หมายเหตุค่าใช้จ่าย',
  invoice_totalAmountNotWrittenOff: 'ยอดรวมที่ยังไม่ตัดจ่าย',
  invoice_receivablesInvoicing: 'ใบแจ้งหนี้ที่ต้องรับ',
  invoice_payablesInvoicing: 'การออกใบแจ้งหนี้ที่ต้องจ่าย',
  invoice_payablesCollectInvoice: 'การรับใบแจ้งหนี้ที่ต้องจ่าย',
  invoice_invoicingType: 'ประเภทการออกใบแจ้งหนี้',
  invoice_makeType: 'ชนิดของใบแจ้งหนี้',
  invoice_invoiceStatus: 'สถานะใบแจ้งหนี้',
  invoice_makePaper: 'ใบแจ้งหนี้แบบกระดาษ',
  invoice_makeElectronic: 'ใบแจ้งหนี้อิเล็กทรอนิกส์',
  invoice_consolidatedInvoice: 'การออกใบแจ้งหนี้แบบรวมกลุ่ม (จัดกลุ่มตามหน่วยการชำระเงิน)',
  invoice_consolidatedInvoiceCollect: 'การรับใบแจ้งหนี้แบบรวมกลุ่ม (จัดกลุ่มตามหน่วยการชำระเงิน)',
  invoice_invoicingAccordingToBusiness: 'การออกใบแจ้งหนี้ตามธุรกิจ (จัดกลุ่มตามหน่วยการชำระเงิน)',
  invoice_invoicingAccordingToBusinessCollect: 'การรับใบแจ้งหนี้ตามธุรกิจ (จัดกลุ่มตามหน่วยการชำระเงิน)',
  invoice_invoicingAccordingToRecords: 'การออกใบแจ้งหนี้ตามรายการ (แต่ละรายการสร้างใบแจ้งหนี้หนึ่งใบ)',
  invoice_invoicingAccordingToRecordsCollect: 'การรับใบแจ้งหนี้ตามรายการ (แต่ละรายการสร้างใบแจ้งหนี้หนึ่งใบ)',
  invoice_invoicingPerRecord: 'แต่ละรายการสร้างใบแจ้งหนี้หนึ่งใบ',
  invoice_invoiceType: 'ประเภทใบแจ้งหนี้',
  invoice_CollectInvoiceType: 'ประเภทการรับใบแจ้งหนี้',
  invoice_invoicingAccordingToCurrency: 'การออกใบแจ้งหนี้แยกตามสกุลเงิน',
  invoice_invoicingAccordingToCurrencyCollect: 'การรับใบแจ้งหนี้แยกตามสกุลเงิน',
  invoice_invoicingPerCurrency: 'การออกใบแจ้งหนี้แยกสกุลเงิน',
  invoice_invoicingPerCurrencyCollect: 'การรับใบแจ้งหนี้แยกสกุลเงิน',
  invoice_specifyInvoiceCurrency: 'ระบุสกุลเงินใบแจ้งหนี้',
  invoice_consolidatedCurrency: 'รวมสกุลเงิน',
  invoice_invoicingCurrency: 'สกุลเงินการออกใบแจ้งหนี้',
  invoice_invoiceExchangeRate: 'อัตราแลกเปลี่ยนใบแจ้งหนี้',
  invoice_invoicingCurrencyCollect: 'สกุลเงินการรับใบแจ้งหนี้',
  invoice_showChargeDetails: 'แสดงรายละเอียดค่าใช้จ่ายในใบแจ้งหนี้',
  invoice_invoicingAccordingToFinancialExchangeRate: 'การออกใบแจ้งหนี้ตามอัตราแลกเปลี่ยนทางการเงิน',
  invoice_invoicingAccordingToFinancialExchangeRateCollect: 'การรับใบแจ้งหนี้ตามอัตราแลกเปลี่ยนทางการเงิน',
  invoice_invoicingAccordingByBillingExchangeRate: 'การออกใบแจ้งหนี้ตามอัตราแลกเปลี่ยนบิล',
  invoice_invoicingAccordingByBillingExchangeRateCollect: 'การรับใบแจ้งหนี้ตามอัตราแลกเปลี่ยนบิล',
  invoice_generateCostInvoice: 'สร้างใบแจ้งหนี้ต้นทุน',
  invoice_subTotal: 'รวมย่อย',
  invoice_exchangeRate: 'อัตราแลกเปลี่ยน',
  invoice_alwaysInvoicing: 'ออกใบแจ้งหนี้ตามอัตราแลกเปลี่ยนนี้เสมอ',
  invoice_SplitChargeOnlyChangeQuantity: '"ราคาต่อหน่วย" ไม่เปลี่ยนแปลงหลังจากแยก "ปริมาณ" อัปเดต',
  invoice_total: 'รวมทั้งหมด',
  invoice_revenueAndExpenditureType: 'ประเภทการรับ/จ่าย',
  invoice_invoicingExchangeRate: 'อัตราแลกเปลี่ยนการออกใบแจ้งหนี้',
  invoice_InvoicingAmount: 'จำนวนเงินการออกใบแจ้งหนี้',
  invoice_billBusinessNo: 'หมายเลขบิล/ธุรกิจ',
  invoice_billBusinessDate: 'วันที่บิล/ธุรกิจ',
  invoice_accountBillBusinessDate: 'หมายเลขใบแจ้งยอด/บิล/ธุรกิจ',
  invoice_paymentNotificationAndBusiness: 'หมายเลขแจ้งการชำระเงิน/ธุรกิจ',
  invoice_invoiceInformation: 'ข้อมูลใบแจ้งหนี้',
  invoice_invoiceContent: 'เนื้อหาใบแจ้งหนี้',
  invoice_chargeDetails: 'รายละเอียดค่าใช้จ่าย',
  invoice_unitPrice: 'ราคาต่อหน่วย',
  invoice_amount: 'จำนวนเงิน',
  invoice_invoiceNo: 'หมายเลขใบแจ้งหนี้',
  invoice_invoiceDate: 'วันที่ออกใบแจ้งหนี้',
  invoice_invoicingDate: 'วันที่ใบแจ้งหนี้',
  invoice_bargeETD: 'วันที่ออกเรือแบนจ์',
  invoice_billPaymentNo: 'เลขที่แจ้งการชำระเงิน',
  invoice_proofDate: 'วันที่เอกสารหลักฐาน',
  invoice_writeOffStatus: 'สถานะการตรวจสอบ',
  invoice_redChargesStatus: 'สถานะการยกเลิกด้วยสีแดง',
  invoice_printOrNot: 'พิมพ์หรือไม่',
  invoice_invalidOrNot: 'ยกเลิกหรือไม่',
  invoice_exportOrNot: 'ส่งออกหรือไม่',
  invoice_invoiceApplicant: 'ผู้ขอออกใบแจ้งหนี้',
  invoice_invoiceVoider: 'ผู้อนุมัติการยกเลิกใบแจ้งหนี้',
  invoice_invoiceVoidTime: 'เวลาที่ยกเลิกใบแจ้งหนี้',
  invoice_totalCurrency: 'รวมตามสกุลเงิน',
  invoice_notWrittenOffTotalCurrency: 'รวมตามสกุลเงินที่ยังไม่ตรวจสอบ',
  invoice_alreadyExportOrNot: 'ส่งออกแล้วหรือไม่',
  invoice_havingInvoiceingNoOrNot: 'มีเลขที่ใบแจ้งหนี้หรือไม่',
  invoice_exportProofFinancialOrNot: 'ส่งออกเอกสารทางการเงินหรือไม่',
  invoice_totalAmount: 'รวมจำนวนเงิน',
  invoice_taxFreeAmount: 'ไม่รวมภาษี',
  invoice_customJobType: 'ประเภทธุรกิจที่กำหนดเอง',
  invoice_userDefinedField1: 'ฟิลด์ที่กำหนดเอง 1',
  invoice_userDefinedField2: 'ฟิลด์ที่กำหนดเอง 2',
  invoice_userDefinedField3: 'ฟิลด์ที่กำหนดเอง 3',
  invoice_userDefinedField4: 'ฟิลด์ที่กำหนดเอง 4',
  invoice_containerNo: 'เลขที่ตู้คอนเทนเนอร์',
  invoice_voyageLine: 'เส้นทางเดินเรือ',
  invoice_separateNumber: 'เลขที่ใบแยก',
  invoice_sp1: 'สำเนาใบแจ้งหนี้',
  invoice_sp2: 'หน่วยงานผู้ชำระเงิน',
  invoice_sp3: 'เลขที่ใบแจ้งหนี้',
  invoice_sp4: 'ล้าง',
  invoice_sp5: 'วันที่ออกใบแจ้งหนี้',
  invoice_sp6: 'สกุลเงินเดิม',
  invoice_sp7: 'สกุลเงินใบแจ้งหนี้',
  invoice_sp8: 'ธนาคารฝ่ายเรา',
  invoice_sp9: 'เลขที่บัญชีฝ่ายเรา',
  invoice_sp10: 'สถานที่เริ่มต้นการขนส่ง',
  invoice_sp11: 'ท่าเรือขนถ่ายสินค้า',
  invoice_sp12: 'จุดหมายปลายทาง',
  invoice_sp13: 'วันที่ออกเรือ',
  invoice_sp14: 'วันที่ถึงท่าเรือ',
  invoice_sp15: 'ข้อกำหนดการออกใบแจ้งหนี้',
  invoice_sp16: 'ชื่อเรือและเที่ยวบิน',
  invoice_sp17: 'แสดงรายละเอียด',
  invoice_sp18: 'รวมรายละเอียด',
  invoice_sp19: 'สินค้า',
  invoice_sp20: 'จำนวนเงินเดิม',
  invoice_sp21: 'จำนวนเงินที่คำนวณใหม่',
  invoice_sp22: 'จำนวนเงินที่คำนวณใหม่',
  invoice_sp23: 'หมายเหตุ',
  invoice_sp24: 'คำอธิบายทางการเงิน',
  invoice_sp25: 'ยอดรวมเงิน',
  invoice_sp26: 'รวม',
  invoice_sp27: 'ตราประทับบริษัท',
  invoice_sp28: 'ตรวจสอบ',
  invoice_sp29: 'เลขทะเบียนภาษี',
  invoice_theLastPage: 'ก่อนหน้า',
  invoice_theNextPage: 'ถัดไป',
  invoice_sp30: 'ตั้งค่าข้อมูลใบแจ้งหนี้เริ่มต้นจากครั้งนี้',
  invoice_sp31: 'แยกค่าใช้จ่าย',
  invoice_back: 'ขั้นตอนก่อนหน้า',
  invoice_selectInvoiceNo: 'เลือกหมายเลขใบแจ้งหนี้',
  invoice_next: 'ขั้นตอนถัดไป',
  invoice_invoiceConfirmation: 'ยืนยันการออกใบแจ้งหนี้',
  invoice_collectInvoiceConfirmation: 'ยืนยันการรับใบแจ้งหนี้',
  invoice_save: 'บันทึก',
  invoice_print: 'พิมพ์',
  invoice_printAll: 'พิมพ์ทั้งหมด',
  invoice_CATISExport: 'ส่งออกข้อมูลภาษี',
  invoice_CATISPrint: 'พิมพ์ข้อมูลภาษี',
  invoice_CATISInvalid: 'ยกเลิกข้อมูลภาษี',
  invoice_cancel: 'ยกเลิก',
  invoice_close: 'ปิด',
  invoice_view: 'ดู',
  invoice_forceDelete: 'ลบแบบบังคับ',
  invoice_delete: 'ลบ',
  invoice_invalid: 'ยกเลิก',
  invoice_exportVATInvoice: 'ส่งออกใบแจ้งหนี้ VAT',
  invoice_importVATInvoice: 'นำเข้าใบแจ้งหนี้ VAT',
  invoice_applyForPayment: 'ขออนุมัติการจ่ายเงิน',
  invoice_sp32: 'ส่งออก Baiwang',
  invoice_billPaymentState: 'สถานะคำขอจ่ายเงิน',
  invoice_downLoad: 'ดาวน์โหลด',
  invoice_BatchDownloadElectronicInvoice: 'ดาวน์โหลดใบแจ้งหนี้อิเล็กทรอนิกส์แบบกลุ่ม',
  invoice_UpdateInvoice: 'แก้ไขใบแจ้งหนี้',
  invoice_ModifyInvoiceInformation: 'แก้ไขข้อมูลใบแจ้งหนี้',
  invoice_recheck: 'ตรวจสอบ',
  invoice_cancelRecheck: 'ยกเลิกการตรวจสอบ',
  invoice_approvedStatue: 'สถานะการตรวจสอบ',
  invoice_approvedBy: 'ผู้ตรวจสอบ',
  invoice_dateApproved: 'วันที่ตรวจสอบ',
  invoice_incomePayDate: 'กำหนดเวลาชำระเงิน',
  invoice_isExtended: 'เกินกำหนดหรือไม่',
  invoice_incomeCostDate: 'กำหนดเวลาชำระเงิน',
  invoice_incomeCostRange: 'ช่วงเวลาที่เกินกำหนด',
  invoice_sellTitle: 'หน่วยขาย',
  invoice_placeOfDelivery: 'สถานที่รับสินค้า',
  invoice_differenceAdjustment: 'ปรับส่วนต่าง',
  invoice_businessCreateDate: 'วันที่สร้างธุรกรรม',
  invoice_dateTo: 'ถึง',
  invoice_lockCheckBoxDate: 'ค้นหาข้อมูลเกิน 2 ปี',
  invoice_queryLotsOfData: 'ค้นหาข้อมูลนอกเหนือจาก 2 ปี',
  invoice_invoiceDateNotEmpty: 'วันที่ใบแจ้งหนี้ไม่สามารถเว้นว่างได้!',
  invoice_unlockInvoiceDateQuery: 'หากช่วงวันที่ใบแจ้งหนี้ที่เลือกมากกว่า 2 ปี จะส่งผลต่อความเร็วในการโหลดข้อมูล ต้องการค้นหาข้อมูลนอกเหนือจาก 2 ปีหรือไม่?',
  invoice_businessDateNotEmpty: 'วันที่ดำเนินงานไม่สามารถเว้นว่างได้!',
  invoice_unlockBusinessDateQuery: 'หากช่วงวันที่ดำเนินงานที่เลือกมากกว่า 2 ปี จะส่งผลต่อความเร็วในการโหลดข้อมูล ต้องการค้นหาข้อมูลนอกเหนือจาก 2 ปีหรือไม่?',
  invoice_actualReceiptDate: 'วันที่รับเอกสารจริง',
  invoice_targetVoucherNo: 'เลขที่เอกสารของคู่กรณี',
  invoice_voucherDate: 'วันที่เอกสาร 2',
  invoice_redPunch: 'การยกเลิกใบแจ้งหนี้',
  invoice_etd: 'ETD (วันที่ออกเดินทางโดยประมาณ)',
  invoice_eta: 'ETA (วันที่ถึงโดยประมาณ)',
  invoice_notesOnReceipt: 'หมายเหตุการรับเอกสาร',
  invoice_invoiceRemarks: 'หมายเหตุใบแจ้งหนี้',
  invoice_settleDepartmentPrefix: 'ฝ่ายชำระเงิน',
  invoice_denomination: 'แยกตามสกุลเงิน',
  lastInvoicingDate: 'วันที่ออกใบแจ้งหนี้ล่าสุด',
  invoice_ATD: 'ATD (วันที่ออกเดินทางจริง)',
  invoice_OperationTime: 'วันที่ดำเนินการ',
  invoice_updateRemark: 'แก้ไขหมายเหตุ',
  OurBankAccountNo: 'เลขที่บัญชีธนาคารของเรา',
  OurBankCurrency: 'สกุลเงินบัญชีธนาคารของเรา',
  RedChargesOrNot: 'ต้องการยกเลิกใบแจ้งหนี้หรือไม่',
  revenueAndExpenditureType: 'ประเภทรายรับรายจ่าย',
  InvoiceDateCreated: 'วันที่สร้างใบแจ้งหนี้',
  ElInvoiceSendStatus: 'สถานะการส่งใบแจ้งหนี้อิเล็กทรอนิกส์',
  ElInvoiceSendPlatformStatus: 'สถานะการส่งใบแจ้งหนี้อิเล็กทรอนิกส์ไปยังแพลตฟอร์ม',
  ElInvoiceSendEmailStatus: 'สถานะการส่งใบแจ้งหนี้อิเล็กทรอนิกส์ไปยังอีเมล',
  InvoicingByBusinessDateExchangeRate: 'ออกใบแจ้งหนี้ตามอัตราแลกเปลี่ยนวันที่ดำเนินงาน',
  InvoicingByBusinessDateExchangeRateCollect: 'รับเอกสารตามอัตราแลกเปลี่ยนวันที่ดำเนินงาน',
  InvoicingByBusinessDateExchangeRateTips: 'กรุณาเลือกค่าใช้จ่ายในวันที่ดำเนินงานเดียวกันเพื่อออกใบแจ้งหนี้!',
  existUnconfirmedStatus: 'ใบแจ้งหนี้ที่เลือกมีสถานะ "ยังไม่ยืนยัน" ต้องการออกใบแจ้งหนี้ต่อหรือไม่',
  AutoCheckInvoicing: 'เลือกออกใบแจ้งหนี้อัตโนมัติ',
  AutoCheckInvoicingToolTips: 'หลังจากใช้งานจะเลือกจำนวนเงินใบแจ้งหนี้ที่ใกล้เคียงหรือเท่ากับจำนวนเงินที่กำหนดไว้ หมายเหตุ: ฟังก์ชันนี้จะไม่ออกใบแจ้งหนี้อัตโนมัติ หากต้องการออกใบแจ้งหนี้ กรุณาดำเนินการด้วยตนเอง',
  DefaultInvoicingAmount: 'จำนวนเงินที่กำหนดไว้สำหรับออกใบแจ้งหนี้:',
  AutoCheckInvoicingAmount: 'เลือกจำนวนเงินออกใบแจ้งหนี้อัตโนมัติ',
  AutoCheckInvoicingDialogToolTips: 'จำนวนเงินรวมที่เลือกอัตโนมัติจะใกล้เคียงหรือเท่ากับจำนวนเงินที่กำหนดไว้',
  AutoSplitCharge: 'แยกค่าใช้จ่ายอัตโนมัติ',
  AutoCalculateSplit: 'คำนวณการแยกอัตโนมัติ',
  AutoCalculateSplitResult: 'ผลการแยกอัตโนมัติ',
  IncludingTaxAmountLimit: 'ราคาสูงสุดรวมภาษี:',
  AutoCheckInvoicingSuccess: 'ดำเนินการเสร็จสิ้น จำนวนเงินค่าใช้จ่ายที่เลือกเทียบเท่าเป็นเงินหยวน: {0} หยวน หากต้องการแก้ไข กรุณาเลือกและปรับปรุงด้วยตนเอง',
  UseAutoCheckInvoicing: 'เลือกค่าใช้จ่ายตามจำนวนเงินที่กำหนดไว้สำหรับออกใบแจ้งหนี้',
  AutoAmountCanNotZero: 'จำนวนเงินที่กำหนดไว้สำหรับออกใบแจ้งหนี้ต้องมากกว่า 0!',
  ArMoreApForAutoCheckInvoicing: 'ดำเนินการเสร็จสิ้น จำนวนเงินที่ต้องจ่ายที่เลือกอัตโนมัติมากกว่าจำนวนเงินที่ต้องได้รับ การออกใบแจ้งหนี้โดยตรงจะถือเป็นการรับเอกสาร แนะนำให้ปรับปรุงด้วยตนเอง',
  invoice_invoicingAccordingToSettlementAgent: 'ออกใบแจ้งหนี้รวม (ออกใบแจ้งหนี้ตามกลุ่มตัวแทนชำระเงิน)',
  invoice_invoicingAccordingToSettlementAgentCollect: 'รับเอกสารรวม (รับเอกสารตามกลุ่มตัวแทนชำระเงิน)',
  invoice_invoicingAccordingToTitle: 'ออกใบแจ้งหนี้ตามชื่อ (แต่ละชื่อใบแจ้งหนี้สร้างใบแจ้งหนี้หนึ่งใบ)',
  invoice_invoicingAccordingToTitleCollect: 'รับใบแจ้งหนี้ตามชื่อ (แต่ละชื่อใบแจ้งหนี้สร้างใบแจ้งหนี้หนึ่งใบ)',
  RequestTaxControlPlatformStatus: 'การร้องขอไปยังแพลตฟอร์มควบคุมภาษีสำเร็จหรือไม่',
  GetInvoiceNumber: 'รับเลขที่ใบแจ้งหนี้',
  NotDoInvoice: 'ยังไม่ออกใบแจ้งหนี้บน Cloud Tax กรุณาออกใบแจ้งหนี้ก่อน',
  GetInvoiceNoSuccess: 'กำลังรับเลขที่ใบแจ้งหนี้ กรุณาตรวจสอบในภายหลัง!',
  GetInvoiceNoFail: 'ไม่สามารถรับหมายเลขใบแจ้งหนี้ได้!',
  NotDoInvoiceBwjsy: 'ยังไม่ได้ออกใบแจ้งหนี้ใน Baiwang Jinsui Cloud โปรดออกใบแจ้งหนี้ก่อน!',
  GetInvoiceNoSuccessBwjsy: 'รับหมายเลขใบแจ้งหนี้สำเร็จ!',
  GetInvoiceNoFailPart: 'ไม่สามารถรับหมายเลขใบแจ้งหนี้บางส่วนได้ โปรดลองอีกครั้งในภายหลัง!',
  NotInvoice: 'ยังไม่ได้ออกใบแจ้งหนี้ โปรดออกใบแจ้งหนี้ก่อน',
  PaperTicketPrinting: 'พิมพ์ใบแจ้งหนี้กระดาษ',
  NameOfSeller: 'ชื่อหน่วยขายสินค้า',
  CNYReceived: 'รับแล้วเทียบเท่า CNY',
  CNYNotReceived: 'ยังไม่ได้รับเทียบเท่า CNY',
  CNYPaid: 'จ่ายแล้วเทียบเท่า CNY',
  CNYNotPaid: 'ยังไม่จ่ายเทียบเท่า CNY',
  InvoiceNoImport: 'นำเข้าเลขใบแจ้งหนี้',
  SpecificConstraintTypes: 'ประเภทข้อจำกัดเฉพาะ',
  PurchaserInformation: 'ข้อมูลผู้ซื้อ',
  SellerInformation: 'ข้อมูลผู้ขาย',
  TypeOfTransport: 'ประเภทยานพาหนะ',
  TransportVehicleBrand: 'ป้ายทะเบียนยานพาหนะ',
  Origin: 'จุดเริ่มต้น',
  Destination: 'จุดหมายปลายทาง',
  NameOfGoodsTransported: 'ชื่อสินค้าที่ขนส่ง',
  ServiceOfGoodsTransported: 'บริการขนส่งสินค้า',
  FeiRedApplicationStatus: 'สถานะการขอใบแจ้งหนี้สีแดงแบบอิเล็กทรอนิกส์เต็มรูปแบบ',
  RedFlushReason: 'สาเหตุการทำใบแจ้งหนี้สีแดง',
  RedApplyFail: 'การขอใบแจ้งหนี้สีแดงล้มเหลว โปรดตรวจสอบสาเหตุความล้มเหลว',
  RedApplying: 'ได้ส่งคำขอใบแจ้งหนี้สีแดงแล้ว โปรดรอให้การขอสำเร็จก่อนดำเนินการ "ส่งออกข้อมูลภาษีทอง"',
  BatchCheckNotRedStatus: 'รองรับเฉพาะใบแจ้งหนี้ที่อยู่ในสถานะสีแดงเท่านั้น โปรดเลือกใหม่และดำเนินการให้เสร็จสิ้น',
  BatchCheckNotRedApplyInvoice: 'รองรับเฉพาะใบแจ้งหนี้ที่ยังไม่ได้ขอสีแดงหรือขอไม่สำเร็จเท่านั้น โปรดเลือกใหม่และดำเนินการให้เสร็จสิ้น',
  BatchCheckRedApplySuccessInvoice: 'รองรับเฉพาะใบแจ้งหนี้ที่ขอสีแดงสำเร็จเท่านั้น โปรดเลือกใหม่และดำเนินการให้เสร็จสิ้น',
  BatchCheckRedFlushInvoice: 'รองรับเฉพาะการดำเนินการกับใบแจ้งหนี้ที่มีสถานะเดียวกันเป็นชุดเท่านั้น โปรดเลือกใหม่และดำเนินการให้เสร็จสิ้น',
  BatchCheckRedFlushInvoiceType: 'รองรับเฉพาะการดำเนินการกับใบแจ้งหนี้แบบอิเล็กทรอนิกส์เต็มรูปแบบเป็นชุดเท่านั้น โปรดเลือกใหม่และดำเนินการให้เสร็จสิ้น',
  BatchCheckRedFlushInvoiceTipOne: 'ที่เลือกไว้',
  BatchCheckRedFlushInvoiceTipTwo: 'ใบแจ้งหนี้จะถูกทำเป็นสีแดง',
  IncorrectInvoicing: 'ออกใบแจ้งหนี้ผิดพลาด',
  SalesReturn: 'สินค้าถูกส่งคืน',
  ServiceTermination: 'บริการสิ้นสุด',
  SalesAllowance: 'ส่วนลดการขาย',
  AllElectricInvoicing: 'ออกใบแจ้งหนี้แบบอิเล็กทรอนิกส์เต็มรูปแบบ',
  RealPersonAuth: 'การยืนยันตัวตนหมดอายุแล้ว',
  PersonAuth: 'การยืนยันตัวตน',
  WeChatScanningAgain: 'โปรดเปิดแอปภาษี ไปที่หน้าล็อกอิน เลือกธุรกิจส่วนบุคคล ล็อกอินด้วยการสแกนหน้า หลังจากป้อนบัญชี (หมายเลขโทรศัพท์) แล้วสแกนหน้าเพื่อล็อกอิน เมื่อสำเร็จแล้วสามารถสแกน QR Code เพื่อยืนยันตัวตนได้',
  Certified: 'ยืนยันแล้ว',
  QdWarningTip: 'กรมสรรพากรกำลังปรับปรุงอินเทอร์เฟซการออกใบแจ้งหนี้แบบอิเล็กทรอนิกส์เต็มรูปแบบอย่างเร่งด่วน ขณะนี้โปรแกรมเมอร์กำลังทำงานอย่างหนัก ในระหว่างการอัปเกรดอินเทอร์เฟซ โปรดไปที่เว็บไซต์สรรพากรเพื่อดำเนินการออกใบแจ้งหนี้ ขออภัยในความไม่สะดวกที่เกิดขึ้น',
  FailureDescription: 'คำอธิบายเกี่ยวกับแพลตฟอร์มควบคุมภาษี',
  SelectRightInvoice: 'โปรดเลือกใบแจ้งหนี้ที่ตรงตามเงื่อนไข!',
  ApplyRed: 'ขอใบแจ้งหนี้สีแดง',
  CancelApplyRed: 'ยกเลิกการขอใบแจ้งหนี้สีแดง',
  InvoiceNotSyncOrInvalid: 'ใบแจ้งหนี้ยังไม่ซิงค์หรือถูกยกเลิกแล้ว ไม่สามารถทำเป็นสีแดงได้!',
  CloudStarrySkyNotSync: 'ยังไม่ซิงค์กับ Cloud Xingkong ไม่สามารถยกเลิกได้ โปรดซิงค์ก่อน!',
  VoidedSuccessfully: 'ยกเลิกสำเร็จแล้ว',
  RateChangedTip: 'อัตราแลกเปลี่ยนที่ตรงกับวันที่ใบแจ้งหนี้มีการเปลี่ยนแปลง ต้องการอัปเดตอัตราแลกเปลี่ยนใบแจ้งหนี้หรือไม่?',
  RateChangedSuccess: '，การอัพเดตอัตราแลกเปลี่ยนใบแจ้งหนี้ประสบความสำเร็จ！',
  SelectReasonForRedOffsetInvoice: 'กรุณาเลือกเหตุผลในการยกเลิกใบแจ้งหนี้',
  OnlyMaster: 'เฉพาะใบแจ้งหนี้หลัก',
  invoice_chargeCurrencyRate1: 'อัตราแลกเปลี่ยนตามสกุลเงิน 1',
  invoice_chargeCurrencyRate2: 'อัตราแลกเปลี่ยนตามสกุลเงิน 2',
  GetInvoiceNumberVietnam: 'ค้นหาหมายเลขใบแจ้งหนี้เวียดนาม',
  GetInvoicePdfVietnam: 'ดาวน์โหลดใบแจ้งหนี้เวียดนาม',
  GetInvoiceStateVietnam: 'ตรวจสอบสถานะใบแจ้งหนี้เวียดนาม',
  PaymentMethodVietnam: 'วิธีการชำระเงินเวียดนาม',
  InvoiceStateVietnam: 'สถานะใบแจ้งหนี้เวียดนาม',
  PleaseThanOneInvoiceMerge: 'โปรดเลือกใบแจ้งหนี้มากกว่าหนึ่งใบเพื่อรวม',
  Verification: 'การตรวจสอบ',
  InvoiceDocument: 'เอกสารใบแจ้งหนี้',
  Missing: 'ขาดหายไป',
  StartingPleaseWaitForEmail: 'เริ่มดำเนินการรวมใบแจ้งหนี้ โปรดรออีเมลผลลัพธ์',
  NoExistsInTheData: 'ไม่มีไฟล์ใบแจ้งหนี้ในข้อมูลที่เลือก!'
}
